import { getAxiosInstance } from "../ApiConfig";

async function getAllEmailTemplates() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllEmailTemplate`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function userNotification() {
    try {
        const response = await getAxiosInstance().get(`/userNotification`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findRecivedEmailActivityByUser() {
    try {
        const response = await getAxiosInstance().get(`/findRecivedEmailActivityByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function emailTemplateAccessUpadet(templateId, action, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/enableOrDisableEmailTemplate/${templateId}/${action}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function notificationStatus(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/notification/status/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    getAllEmailTemplates,
    emailTemplateAccessUpadet,
    userNotification,
    notificationStatus,
    findRecivedEmailActivityByUser
}